import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { PanelDetailLocationsService } from "../../../services/Panel-Detail-Locations.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { EnumLocationCategories, EnumLocationCategoriesSpanish } from "../../../../shared/helpers/enums/EnumLocationCategories";
import { MapHelperService } from "src/services/map-helper.service";
import { Subscription } from "rxjs";

@Component({
  selector: "panel-detail-locations",
  templateUrl: "./panel-detail-locations.component.html",
  styleUrls: ["./panel-detail-locations.component.css"],
})
export class PanelDetailLocationsComponent implements OnInit, OnDestroy {
  
  fullScreen: boolean = false;

  enumLocationCategories = EnumLocationCategories;
  enumLocationCategoriesSpanish = EnumLocationCategoriesSpanish;
  enumLocationCategoriesValues: string[];
  enumLocationCategoriesValuesSpanish: string[];
  isVisibleDetails: boolean;
  categorySelected: string = "";
  itWorksAsVirtualLocationCategory: boolean = false;
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();
  $categorySelected: Observable<string> = new Observable<string>();

  suscription_categorySelected: Subscription;
  suscription_getLoading: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private panelDetalilService: PanelDetailLocationsService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private mapHelperService: MapHelperService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.enumLocationCategoriesValues = Object.values(this.enumLocationCategories).map(value => value.toLowerCase());
    this.enumLocationCategoriesValuesSpanish = Object.values(this.enumLocationCategoriesSpanish).map(value => value.toLowerCase());
    this.$categorySelected = this.panelDetalilService.getCategorySelected();
    this.suscription_categorySelected = this.$categorySelected.subscribe((element) => {
      this.categorySelected = element;
      console.log("categorySelected", element, this.isVisibleDetails);
      if (localStorage.getItem("listaCategorias") !== null && !!element) {
        const listaCategorias = JSON.parse(localStorage.getItem("listaCategorias"));
        this.itWorksAsVirtualLocationCategory = listaCategorias.some((category: any) => (category.name.toLowerCase() === element.toLowerCase()  && category.itWorksAsVirtualLocation === true));
      }
    });
    this.suscription_getLoading = this.panelDetalilService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.suscription_categorySelected) {
      this.suscription_categorySelected.unsubscribe();
    }
    if (this.suscription_getLoading) {
      this.suscription_getLoading.unsubscribe();
    }
  }

  CancelButton(){
    if (this.mapHelperService.locationsubscription) {
      this.mapHelperService.locationsubscription.unsubscribe();
    }
    this.categorySelected = "";
    this.itWorksAsVirtualLocationCategory = false;

    this.panelDetalilService.setLoading(false);
    this.panelDetalilService.setVisibilityPopup(false);
  }

  
}
